'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _deprecated = require('../utils/propTypes/deprecated');

var _deprecated2 = _interopRequireDefault(_deprecated);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _ShareInput = require('../decorators/ShareInput');

var _ShareInput2 = _interopRequireDefault(_ShareInput);

var _IMESafe = require('../decorators/IMESafe');

var _IMESafe2 = _interopRequireDefault(_IMESafe);

var _InputConstants = require('./InputConstants');

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

var _Functions = require('../core/Functions');

var _FieldsetContext = require('../context/FieldsetContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createWarningMessage = function createWarningMessage(propName) {
  return {
    message: 'UITextArea: the ' + propName + ' prop has been deprecated. Please use `UICharacterCounter` instead.',
    key: 'UITextArea: ' + propName + ' prop'
  };
};

var UITextArea = _react2.default.createClass({
  displayName: 'UITextArea',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    cols: _react.PropTypes.number,
    counter: (0, _deprecated2.default)(_react.PropTypes.bool, createWarningMessage),
    disabled: _react.PropTypes.bool,
    error: _react.PropTypes.bool,
    inputRef: _refObject2.default,
    placeholder: _react.PropTypes.string,
    readOnly: _react.PropTypes.bool,
    resize: _react.PropTypes.oneOf(['vertical', 'horizontal', true, false]),
    rows: _react.PropTypes.number,
    styled: _react.PropTypes.bool.isRequired,
    use: _react.PropTypes.oneOf(Object.keys(_InputConstants.USE_CLASSES)),
    value: _react.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      error: false,
      resize: 'vertical',
      styled: true,
      value: ''
    };
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        counter = _props.counter,
        error = _props.error,
        inputRef = _props.inputRef,
        resize = _props.resize,
        styled = _props.styled,
        use = _props.use,
        value = _props.value,
        rest = _objectWithoutProperties(_props, ['className', 'counter', 'error', 'inputRef', 'resize', 'styled', 'use', 'value']);

    return _react2.default.createElement(
      _FieldsetContext.Consumer,
      null,
      function (_ref) {
        var fieldSize = _ref.size;

        var computedClassName = (0, _classNames2.default)('form-control', 'private-form__control', 'private-text-area', className, _InputConstants.INPUT_SIZE_OPTIONS[fieldSize], _InputConstants.USE_CLASSES[use], {
          'private-text-area--with-counter': counter,
          'private-form__control--unstyled': !styled,
          'private-form__control--error': error,
          'private-text-area--no-resize': resize === false,
          'private-text-area--vertical-resize': resize === 'vertical',
          'private-text-area--horizontal-resize': resize === 'horizontal'
        });

        var renderedTextArea = _react2.default.createElement('textarea', _extends({}, rest, {
          className: computedClassName,
          ref: (0, _Functions.wrapRefObject)(inputRef),
          value: value
        }));

        if (counter) {
          var count = value ? value.length : 0;
          return _react2.default.createElement(
            'div',
            { className: 'private-text-area__counter-wrapper' },
            renderedTextArea,
            _react2.default.createElement(
              'span',
              {
                className: 'private-text-area__counter',
                'aria-live': 'polite',
                'aria-atomic': 'false'
              },
              count === 1 ? _I18n2.default.text('salesUI.UITextArea.characterCounter.one', {
                count: count
              }) : _I18n2.default.text('salesUI.UITextArea.characterCounter.other', {
                count: count
              })
            )
          );
        }

        return renderedTextArea;
      }
    );
  }
});

exports.default = (0, _ShareInput2.default)((0, _IMESafe2.default)((0, _Controllable2.default)(UITextArea)));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/input/UITextArea.js
// module id = 569
// module chunks = 171